import { Component } from '@angular/core';
import { BaseSidebarActivityComponent } from '../base-sidebar-activity/base-sidebar-activity.component';


@Component({
    selector: 'app-me-sidebar-activity',
    templateUrl: './me-sidebar-activity.component.html',
    styleUrls: ['./me-sidebar-activity.component.less'],
    standalone: false
})
export class MeSidebarActivityComponent extends BaseSidebarActivityComponent {
}
